<template>
  <div>
    {{ ActDescBtn }}
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Entrega de productos a clientes sin factura'"
          :show-absolute="false"
          :titulo="'Notas de Entrega a Clientes'"
          @MethodAnular="anular"
          @MethodGuardar="guardar"
          @MethodImprimir="imprimir"
          @MethodNuevo="newnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Barra de busqueda --->
        <v-col v-show="BarraPrimariaAbrir" :max-height="this.windowSize.height - 96" cols="3">
          <div
            class="overflow-y-auto"
            v-bind:style="{
              'max-height': this.windowSize.height - 96 + 'px',
            }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!-- <v-navigation-drawer >  -->

                <BarraDinamicaLimitePlus
                  :ContListSlot="[
                    { Text: 'Secuencia', NomValue: 'secuencia', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Factura', NomValue: 'factura', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Fecha', NomValue: 'fecha', Ctsl: 1, Type: 1, State: true },
                  ]"
                  :PropsList="notaParaClienteList"
                  :PropsNombre="'Notas de Entrega'"
                  :PropsSeachNombre="'Búsqueda por secuencia o factura'"
                  :TbPaginator="TbPaginator"
                  :TbTotalItem="totalItems"
                  :headers="[{ text: 'Código', value: 'secuencia' }]"
                  props-search
                  @CargarPaginacion="CargarPaginacion"
                  @EmitDAta="datostabla"
                />
              </template>
            </v-tooltip>
          </div>
        </v-col>
        <!-- fn Barra de busqueda --->

        <!-- Contenido central --->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <div class="px-2">
              <!---- Formulario ----->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card color="grey lighten-3">
                  <div class="px-2">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-row dense no-gutters>
                          <v-text-field
                            v-model="notaParaCliente.secuencia"
                            dense
                            label="#Secuencia"
                            outlined
                            readonly
                            type="number"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-list-ol" style="font-size: 20px; width: 20px"></i>
                            </template>
                          </v-text-field>

                          <v-text-field
                            v-model="notaParaCliente.fecha"
                            :rules="[$rules.required]"
                            class="ml-lg-2"
                            dense
                            label="Fecha"
                            outlined
                            type="date"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px; width: 20px"></i>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-autocomplete
                          v-model="notaParaCliente.cliente"
                          :items="clienteList"
                          :rules="[$rules.required]"
                          :search-input.sync="searchCliente"
                          clearable
                          dense
                          item-text="nombre"
                          label="Cliente"
                          no-data-text="No hay clientes disponibles"
                          outlined
                          return-object
                          @focus.once="findCliente"
                        >
                          <template #prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          v-model="notaParaCliente.factura"
                          :rules="[$rules.required]"
                          dense
                          label="#Factura"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-hashtag" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-textarea v-model="notaParaCliente.comentario" dense label="Comentario" outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-commenting-o" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-textarea>
                      </v-col>
                      <!-- fn columna 2 -->

                      <!-- Columna 3 --->
                      <v-col cols="12">
                        <v-data-table
                          :headers="notaHeaders"
                          :items="notaParaCliente.detalles"
                          no-data-text="No hay productos seleccionados"
                        >
                          <template #top>
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <v-row class="px-2 align-center" dense no-gutters>
                                  <v-autocomplete
                                    ref="searchProductoSelect"
                                    :items="searchProductoList"
                                    :search-input.sync="searchProducto"
                                    dense
                                    item-text="descripcion"
                                    label="Buscar producto"
                                    no-filter
                                    return-object
                                    style="max-width: 30rem"
                                    @change="addProducto"
                                  >
                                    <template #item="{ item }">
                                      <b>{{ item.codigo }}</b>
                                      -{{ item.descripcion }}
                                    </template>
                                  </v-autocomplete>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        class="ml-3"
                                        color="green"
                                        small
                                        v-bind="attrs"
                                        @click="addProductoGenerico"
                                        v-on="on"
                                      >
                                        <i class="fa fa-plus-square" style="font-size: 20px; color: white"></i>
                                      </v-btn>
                                    </template>
                                    <span>Agregar Producto Genérico</span>
                                  </v-tooltip>
                                </v-row>
                              </v-col>

                              <v-col class="d-flex justify-end pa-3" cols="12" sm="6">
                                <v-btn color="green" style="color: white" @click="showDialogAddProducto = true">
                                  <i class="fa fa-plus-square" style="width: 20px; font-size: 20px"></i>
                                  Agregar producto
                                </v-btn>
                              </v-col>
                            </v-row>
                          </template>

                          <template v-slot:item.cantidad="{ item }">
                            <v-text-field
                              v-model.number="item.cantidad"
                              dense
                              hide-details
                              min="1"
                              style="font-size: 14px; max-width: 3rem"
                              type="number"
                            ></v-text-field>
                          </template>

                          <template v-slot:item.acciones="{ item }">
                            <v-btn color="red" rounded small @click="removeProducto(item)">
                              <i class="fa fa-trash" style="font-size: 20px; color: white"></i>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                      <!-- fn Columna 3 --->
                    </v-row>
                  </div>
                </v-card>
              </v-form>
              <!---- fn Formulario ----->
            </div>
          </v-app>
        </v-col>
        <!-- fn Contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'AnularCaja'" small @click.prevent="eliminar(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->

    <!--- Dialogo de buscar producto --->
    <v-dialog
      v-model="showDialogAddProducto"
      label="Modal agregar producto"
      max-height="80%"
      max-width="90%"
      persistent
      transition="fab-transition"
    >
      <AgregarProducto ref="addProducto" :statusFoms="showDialogAddProducto" @EmitAgregarProducto="addProductoDialog" />
    </v-dialog>
    <!--- fn Dialogo de buscar producto --->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!--- Dialogo de confirmacion --->
    <DialogoConfirmacion ref="confirmDialog" />
    <!--- fn Dialogo de confirmacion --->

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog
      v-model="showDialogImprimir"
      label="Modal Reporte Basico"
      max-height="50%"
      max-width="80%"
      persistent
      transition="fab-transition"
    >
      <ModalReporteBasico :Datos="dataImpresion" @DataReporteBasico="cerrarReporte" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->

    <div v-if="ejecucion" class="form-loading-indicator">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinamLimite"
  import BarraDinamicaLimite from "../../components/BarraDinamicaLimite"
  import { EventBus } from "../../event-bus.js"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import { currencyFormatter, fechaNueva, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"
  import DialogoConfirmacion from "@/components/DialogoConfirmacion.vue"
  import TablaProductoCxP from "@/CuentaXPagar/UtilidadComponents/TablaProductoCxP.vue"
  import VueAutonumeric from "@/components/AutoNumericNuevo.vue"
  import CreacionProductoMovil from "@/Inventario/Mant/CreacionProductoMovil.vue"
  import AgregarProducto from "@/CuentaXPagar/UtilidadComponents/AgregarProducto.vue"
  import ModalReporteBasico from "@/components/ModalReporteBasico"

  export default {
    components: {
      AgregarProducto,
      CreacionProductoMovil,
      TablaProductoCxP,
      DialogoConfirmacion,
      BarraDinamicaLimite,
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      VueAutonumeric,
      ContenidoBase,
      ModalReporteFiltros,
      ModalReporteBasico,
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("emitAnular", this.datostabla)
      EventBus.$on("AnularNew", this.new)
      // EventBus.$on("AnularSave", this.save);
      EventBus.$on("AnularRemove", this.remove)
      EventBus.$on("AnularAnular", this.save)
    },

    data() {
      return {
        windowSize: { width: "auto", height: "auto" },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        },

        valid: true,

        // Formulario
        notaParaClienteNueva: {
          secuencia: 0,
          cliente: null,
          factura: "",
          comentario: "",
          detalles: [],
          fecha: new Date().toISOString().split("T")[0],
        },

        notaParaCliente: {
          secuencia: 0,
          cliente: null,
          factura: "",
          comentario: "",
          detalles: [],
          fecha: new Date().toISOString().split("T")[0],
        },

        // Listados
        notaHeaders: [
          { text: "Código", value: "producto.codigo", sortable: false },
          { text: "Descripción", value: "descripcion", sortable: false },
          { text: "Cantidad", value: "cantidad", sortable: false },
          { text: "Acciones", value: "acciones", sortable: false },
        ],

        searchCliente: "",
        clienteList: [],

        searchProducto: "",
        searchProductoList: [],

        notaParaClienteList: [],
        totalItems: 0,

        TbTotalItem: 0,
        TbPaginator: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },

        search: "",
        acti_tb_data: false,

        // Modales
        showDialogAddProducto: false,

        // Impresion
        showDialogImprimir: false,
        dataImpresion: {
          nombre: "NOTA PARA CLIENTE",
          UrlImprimir: "/reportes-pv/imprimirNotaParaCliente",
          UrlExel: "/facturasproveedor/excel",
          UrlCorreo: "/facturasproveedor/correo",
          notaParaCliente: this.notaParaCliente,
        },

        ejecucion: false,
        aalert: {
          estado: false,
          color: null,
        },

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        BarraPrimariaAbrir: false,
      }
    },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      fechaNueva,
      getParamFecha,

      // Abriendo una la barra de datos principal.
      abrirTabla() {
        this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir
      },

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e

          this.newnuevo()
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e

          EventBus.$emit("loading", false)
        }
      },

      // Limpia el formulario.
      newnuevo() {
        Object.assign(this.notaParaCliente, this.notaParaClienteNueva)
        this.notaParaCliente.detalles = []
        this.$refs.form.resetValidation()
        this.ejecucion = false
      },

      isDetalleValido() {
        let isCantidadInvalida = this.notaParaCliente.detalles.some((value) => value.cantidad < 1)
        if (this.notaParaCliente.detalles.length === 0 || isCantidadInvalida) {
          let message = isCantidadInvalida
            ? "No se permiten productos con cantidades menores que 1"
            : "No tiene ningun producto asignado"
          this.alerta(message, "error")
          console.log("alla")
          return false
        }

        console.log("aqui")
        return true
      },

      guardar() {
        if (!this.$refs.form.validate() || !this.isDetalleValido()) return

        if (this.notaParaCliente.secuencia === 0) {
          this.save()
        } else {
          this.modificar()
        }
      },

      save() {
        this.$axios
          .post(this.$hostname + this.$hName + `/notasParaClientes`, this.notaParaCliente, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Creacion exitosa!", "bien")
            this.CargarListTb()
            this.newnuevo()
          })
          .catch((error) => {
            this.ejecucion = false
            console.error(error)
            this.alerta("Error al crear!", "error")
          })
      },

      modificar() {
        this.$axios
          .put(this.$hostname + this.$hName + `/notasParaClientes`, this.notaParaCliente, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Modificacion exitosa!", "bien")
            this.CargarListTb()
            this.newnuevo()
          })
          .catch((error) => {
            this.ejecucion = false
            console.error(error)
            this.alerta("Error al modificar!", "error")
          })
      },

      async anular() {
        if (!(await this.$refs.confirmDialog.show())) return

        let secuencia = this.notaParaCliente.secuencia
        this.$axios
          .delete(this.$hostname + this.$hName + `/notasParaClientes/${secuencia}`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Anulacion exitosa!", "bien")
            this.CargarListTb()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al anular!", "error")
          })
      },

      eliminar() {},

      // Se llama cuando se hace clic en una fila de la tabla.
      datostabla(e) {
        Object.assign(this.notaParaCliente, e)
        this.acti_tb_data = false
      },

      // Un metodo que se llama cuando se hace clic en un boton y muestra un modal con todo los registro.
      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.Limpiarfiltro()
      },

      // Limpieza del filtro y recarga los datos de la tabla.
      Limpiarfiltro() {
        var Pg = {
          itemsLength: this.TbPaginator.itemsLength,
          itemsPerPage: this.TbPaginator.itemsPerPage,
          page: 1,
          pageCount: 1,
          pageStart: 0,
          pageStop: this.TbPaginator.itemsPerPage,
        }

        this.TbPaginator = JSON.parse(JSON.stringify(Pg))
        this.CargarListTb()
      },

      // Un metodo que se llama cuando el usuario cambia la página de la tabla.
      CargarPaginacion(e, s) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.TbPaginator = JSON.parse(JSON.stringify(e))
        this.search = s
        this.CargarListTb()
      },

      // Obtener los datos de la lista
      CargarListTb() {
        let secuencia = isNaN(this.search) ? null : this.search

        this.$axios
          .get(this.$hostname + this.$hName + "/notasParaClientes", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              page: this.TbPaginator.page - 1,
              secuencia: secuencia,
              factura: this.search,
            },
          })
          .then((res) => {
            this.notaParaClienteList = res.data.content
            this.totalItems = res.data.totalElements
          })
          .catch((error) => {
            console.error(error)
          })
      },

      // Buscar cliente
      findCliente() {
        this.$axios
          .get(this.$hostname + this.$hName + "/clientes", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              nombre: this.searchCliente,
            },
          })
          .then((res) => {
            this.clienteList = res.data.content
          })
          .catch((err) => {
            console.error(err)
          })
      },

      findProductos() {
        this.$axios
          .get(this.$hostname + this.$hName + "/producto", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              codigo: this.searchProducto,
              descripcion: this.searchProducto,
            },
          })
          .then((res) => {
            this.searchProductoList = res.data.content
          })
      },

      addProducto(item) {
        this.$refs.searchProductoSelect.reset()
        if (!item || this.notaParaCliente.detalles.some((value) => value.descripcion === item.descripcion)) return
        let notaDetalle = {
          producto: item,
          descripcion: item.descripcion,
          cantidad: 1,
        }
        this.notaParaCliente.detalles.unshift(notaDetalle)
      },

      removeProducto(producto) {
        if (!producto) return
        let index = this.notaParaCliente.detalles.indexOf(producto)
        this.notaParaCliente.detalles.splice(index, 1)
      },

      addProductoGenerico() {
        let item = this.searchProducto
        if (!item || this.notaParaCliente.detalles.some((value) => value.descripcion === item)) return

        let notaDetalle = {
          producto: null,
          descripcion: item,
          cantidad: 1,
        }

        this.notaParaCliente.detalles.unshift(notaDetalle)
        this.$refs.searchProductoSelect.reset()
      },

      addProductoDialog(item) {
        if (item.estado === "cerrar") {
          this.showDialogAddProducto = false
        }
        if (item.estado === "datos") {
          this.addProducto(item.datos.productos)
        }
      },

      cerrarReporte() {
        this.showDialogImprimir = false
      },

      imprimir() {
        this.dataImpresion.notaParaCliente = this.notaParaCliente
        this.showDialogImprimir = true
      },
    },

    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
      },
    },

    watch: {
      searchCliente() {
        this.findCliente()
      },

      searchProducto() {
        this.findProductos()
      },

      "notaParaCliente.secuencia"(val) {
        if (val !== 0) {
          this.EstadoBtn.imprimir = true
          this.EstadoBtn.anular = true
        } else {
          this.EstadoBtn.imprimir = false
          this.EstadoBtn.anular = false
        }
      },
    },
  }
</script>

<style>
  .form-loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    padding: 20px;
    border-radius: 4px;
    z-index: 1;
  }
</style>
